/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Represents the state of a rollout wave.
 */
export type RolloutWaveState = 'DRAFT' | 'COMMITTED' | 'IN_PROGRESS' | 'COMPLETED' | 'CANCELED';

export const RolloutWaveState = {

    DRAFT: 'DRAFT' as RolloutWaveState,

    COMMITTED: 'COMMITTED' as RolloutWaveState,

    IN_PROGRESS: 'IN_PROGRESS' as RolloutWaveState,

    COMPLETED: 'COMPLETED' as RolloutWaveState,

    CANCELED: 'CANCELED' as RolloutWaveState
};

